module.exports = __webpack_public_path__ + "shape.png?878e3331a2da811e234e9d474dd85513";